<template>
    <rkm-area
        :subtitle="subtitle"
        color="gestante"
        title="Gestante"
    >
        <Form ref="Form" :item="data.model.gestacao || undefined" :data="data" />
    </rkm-area>
</template>

<script>
import Form from './Form'

export default {
    components: { Form },
    computed: {
        subtitle() {
            if (this.data.form.gestante) {
                return this.data.form.gestante.dataHora.concat(
                    ' | ',
                    this.data.form.gestante.lotacao.profissional.nome
                )
            } else {
                return ''
            }
        }
    },
    props: {
        data: { type: Object, required: true }
    },
}
</script>